export default "__VITE_ASSET__de7851a3__"